export const opinion = [
    {
        id: "content-opinion-a-deeper-look",
        name: "نظرة أعمق",
        articles: [
            {
                id: "7c4b6a7e-1f91-4e43-b099-a72aea0fa6c7",
                class: "columns-3-wide",
                header: "أحدث الحقائق",
                url: "#",
                image: {
                    src: "assets/images/milad-fakurian-58Z17lnVS4U-unsplash_684.jpg",
                    alt: "عنصر نائب",
                    width: "684",
                    height: "385",
                },
                meta: {
                    tag: {
                        type: "breaking",
                        label: "كسر",
                    },
                },
                title: "الجوع القديم ونيتوس و وإنفاذ القانون القبيح.كراهية مضادات الأكسدة موريس الجلوس القداس .لن كرة القدم لكرة القدم السهام لكرة القدم في نهاية الأسبوع الكراهية.",
                type: "text",
                content: "ومن كل يعبأ الصفحات التخطيط. يتم ان أطراف إنطلاق. بل أسر مقاطعة الأثناء،, جعل أي منتصف المنتصر. ذات إذ بالجانب واعتلاء اليابانية, يتعلّق ا قُدُماً تم وتم. هُزم جزيرتي الإمتعاض الى مع.",
            },
            {
                id: "0d292bbd-e6da-499b-8008-652d51e3b26d",
                class: "columns-3-narrow",
                header: "قمة أذهاننا",
                url: "#",
                image: {
                    src: "assets/images/no-revisions-UhpAf0ySwuk-unsplash_336.jpg",
                    alt: "عنصر نائب",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "سعر من الهوية السريرية يرجى جعل سعر درجة الحرارة.تحقيق تشغيل.",
                type: "text",
                content:
                    "لكون إعلان حيث في, ثم لها واتّجه ماليزيا،. الخاصّة الفرنسية في بين. وقام لفرنسا ما لها, ولم كل وسفن تعداد الآخر. قبضتهم ليتسنّى مع وتم, مع وقام ارتكبها غير. بل العالم إستيلاء والمعدات حدى, بل فرنسا التبرعات ولكسمبورغ شيء. إيو كل استبدال تشيكوسلوفاكيا.\n\nما يتبقّ مقاومة معاملة وقد, عجّل أمّا الثانية هذه قد, لم أوزار وتتحمّل كما. مايو بريطانيا، ان مما, حيث من أوسع الأمور. هو يكن ونتج لعملة. بل مكثّفة بالرغم الانجليزية مما. بعد كانت البشريةً كل, شعار استعملت ايطاليا، وصل و. هو مايو أصقاع بلا.",
            },
            {
                id: "75c1fa44-8c39-48a0-9db7-b30c0ffc6606",
                class: "columns-3-narrow",
                header: "تقرير المحرر",
                url: "#",
                image: {
                    src: "assets/images/national-cancer-institute-YvvFRJgWShM-unsplash_336.jpg",
                    alt: "عنصر نائب",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "كرة القدم هي الكثير من الدورة المعقمة.",
                type: "text",
                content:
                    "لم وكسبت بمباركة لبولندا، دنو, قام استطاعوا الدولارات و. الأرض الجنرال الأمريكية إذ ذلك. عن وفي وعُرفت المبرمة. وعلى الثالث، مما ما. ما وفي خلاف الشتوية والديون, مدن السفن الثقيل بريطانيا، أي, قد أما غرّة، رجوعهم التقليدية.\n\nمع مرجع الإقتصادي فقد, في دنو الأجل الصين بالعمل. ذات الطرفين التحالف التغييرات أن. أواخر الشمل الاندونيسية أم مدن. لم تلك أدوات معاملة. حدى أن بمحاولة الخارجية, اليها سبتمبر قبل إذ, بزمام تاريخ تحرّك جعل ما.",
            },
        ],
    },
    {
        id: "content-opinion-top-issues",
        name: "أعلى القضايا",
        articles: [
            {
                id: "68c63699-7843-4f2c-8893-3cd0043ce6c7",
                class: "columns-3-balanced",
                header: "أفكار",
                image: {
                    src: "assets/images/rebe-pascual-SACRQSof7Qw-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "مطورو كرة القدم احتياجات كرة القدم.",
                type: "list",
                content: [
                    {
                        id: "240604e5-bec1-4618-96b2-0779e444bbd6",
                        content: "هو بحق مسرح الحدود, رئيس واستمرت المتساقطة، أم حتى",
                    },
                    {
                        id: "0c00a629-e255-4378-8a83-c03f7931c4ad",
                        content: "أما إعمار الأراضي اليابانية, وجهان لعملة كلّ قد, قائمة والحزب ٣٠",
                    },
                    {
                        id: "1c1c8def-c6a4-46e1-abc3-41f5047fac43",
                        content: "اليميني الأبرياء في. مكن إذ أكثر الأراضي, وصل بل فرنسية العالمي.",
                    },
                    {
                        id: "58d833c6-a8c8-407a-9f19-beca0f8c162f",
                        content: "حصدت وجهان. تلك عل وبدأت لليابان بالرّغم. ٢٠٠٤ احداث قد فصل, ",
                    },
                ],
            },
            {
                id: "f293245c-cbdc-4538-8ca8-0181ba5709a0",
                class: "columns-3-balanced",
                header: "التعليق الاجتماعي",
                image: {
                    src: "assets/images/fanga-studio-bOfCOy3_4wU-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "سهام القوس من الكحول.",
                type: "list",
                content: [
                    {
                        id: "92224182-af6a-4b62-88cb-570784a44f48",
                        content: "مع وتم, فقد أن إختار نتيجة, أهّل القوى إذ بلا. فقامت ارتكبها ما فعل,",
                    },
                    {
                        id: "a6afd1c2-8601-44c0-b0f4-1ce53c49c18e",
                        content: "أحكم التي العدّ فعل مع. حول ما رجوعهم وصافرات.",
                    },
                    {
                        id: "a50daa85-285a-4352-95f0-110d84a29bfe",
                        content: "تلك الدول الصين بمعارضة بل, اتفاقية الأولية وفي ان. لك",
                    },
                    {
                        id: "81b0cb6e-a5d2-4520-9760-91dd4b87b416",
                        content: "استعملت اليابان، هو, يكن قائمة والمانيا التنازلي عل. ما ولم هُزم بريطانيا.",
                    },
                ],
            },
            {
                id: "0f38830e-3f1d-43ee-9f24-dc3f1422e9d7",
                class: "columns-3-balanced",
                header: "مشاريع خاصة",
                image: {
                    src: "assets/images/jakob-dalbjorn-cuKJre3nyYc-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "عدد لعدم وفرنسا أي, وتزويده الأرضية يتم هو. جورج مس",
                type: "text",
                content:
                    "اليابانية استراليا، إذ فعل. من دارت الشطر فاتّبع عدم, كل مما مساعدة الشتاء، ولاتّساع. عن شرسة اعلان بعد, أي سابق الشهيرة فقد. التي أمدها قد كما, إذ تلك النفط الشرق، الخاسر. قد خطّة وبالرغم شموليةً أخذ.\n\nلليابان بمعارضة ما وقد, مئات أحدث لإنعدام هو حتى. مرجع يتبقّ بتخصيص الا ما, إجلاء عسكرياً أم عدم. إعادة الأوضاع أم قبل, المتحدة ولاتّساع بريطانيا لم شيء. شيء هناك أدنى إبّان عن. يبق أن تزامناً الأراضي لبلجيكا،, لكل و مكّن وشعار الثقيلة. و اللا وبعدما الربيع، أسر, بين في جسيمة للصين الأوروبيّون, يعبأ المدن الشتوية نفس كل.",
            },
        ],
    },
    {
        id: "content-opinon-trending",
        name: "الشائع",
        articles: [
            {
                id: "7ca7daac-f4d0-4a57-a396-b8bb485796b4",
                class: "columns-wrap",
                header: "حول العالم",
                type: "excerpt",
                content: [
                    {
                        id: "8b9fef9b-1387-432b-9f0a-a4fbe8525c39",
                        image: {
                            src: "assets/images/dibakar-roy-K9JwokzSvrc-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "إيو كل وباءت وبداية الضغوط, بحشد تجهيز حدى بـ. قد معقل عجّل الساحلية حيث, دون ما والحزب الفترة. أن الأمور البشريةً دار, مع أمّا أخرى الطرفين فقد. و كرسي الثقيل جعل. تعد بولندا، إستيلاء أي, عل جيوب الوراء العمليات ذلك. حاملات إتفاقية وبلجيكا، ٣٠ فقد, بقسوة سبتمبر وايرلندا جهة ما.",
                    },
                    {
                        id: "dbbbe43b-354b-458e-832a-1a1de4e4a68c",
                        image: {
                            src: "assets/images/anatol-rurac-NeSj0i6HLak-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "من هذه بقصف ومحاولة لبولندا،, أوروبا معارضة الفرنسي نفس إذ. كل مدن تشكيل اتّجة, و حتى وجزر الآخر, وتم لإعلان الثقيلة الواقعة كل. هذا هو المارق ويتّفق, هو عسكرياً الإثنان شيء. لكل ارتكبها المتساقطة، ثم, عل حتى حصدت وصافرات. قد ثمّة واحدة واتّجه ذلك.",
                    },
                    {
                        id: "4d5f3465-3649-40d0-a15e-28b4c6c7a333",
                        image: {
                            src: "assets/images/anatol-rurac-b5t2lqeCGfA-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "ثم فكان وبولندا التغييرات بال, أخذ للجزر الخطّة الإنذار، ما. فعل كل بشرية وايرلندا, بـ حول وقرى حادثة والنرويج. وفي ودول العالمي العاصمة عل. جعل بـ لغزو إحتار واعتلاء.",
                    },
                ],
            },
            {
                id: "89639a03-5c46-45c1-ad54-ba8548521eea",
                class: "columns-wrap",
                header: "يدعم",
                type: "excerpt",
                content: [
                    {
                        id: "ac384e2a-611f-4910-8c89-2922238dff84",
                        image: {
                            src: "assets/images/neil-thomas-SIU1Glk6v5k-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "وبدون الصفحات بها في, جيوب وبعد مكن عن. وسفن الستار النزاع وقد بل. وفي عن فرنسا واتّجه المنتصر, ان الأحمر وتنامت تلك. الثالث والفرنسي وصل بل, كل تحرّك المارق عدم. ٣٠ ومن ودول العصبة المواد, عجّل أراض ٣٠ وفي. ودول الواقعة الدنمارك بحث بـ, هذا بالعمل والفرنسي ٣٠.",
                    },
                    {
                        id: "c5622af2-af36-4d93-9fab-5fed3226f48c",
                        image: {
                            src: "assets/images/jon-tyson-ne2mqMgER8Y-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "بل لان الله المجتمع, لمّ ثم غضون ليركز. أم الدول طوكيو بلديهما يكن, أعلنت وصافرات وفي كل, أحدث العالمي عل كلّ. أم عدم مسارح للصين عملية, حصدت الثقيلة لمّ أم. الله الطريق عل كلا, ٣٠ وقد حقول ميناء والعتاد. دفّة ألمّ الإمتعاض بـ حين. استبدال وقدّموا والنرويج تلك تم, للصين الشتوية فصل أي.",
                    },
                    {
                        id: "1e5314da-3b79-4da7-a845-d3c27c37ba70",
                        image: {
                            src: "assets/images/nonresident-nizUHtSIrKM-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "وصل أن بحشد أساسي, وبدأت الأمم واشتدّت جهة ما. الحرة بينما الإثنان أن يبق. ضرب ان دخول تشكيل الانجليزية, القوى المشترك بمباركة ثم فعل. كل دار أفاق أوسع, نفس عل قادة الثانية الشّعبين.",
                    },
                ],
            },
            {
                id: "b4c36ecf-7d2f-4715-842c-a1fe99c0475e",
                class: "columns-wrap",
                header: "تعرف أكثر",
                type: "excerpt",
                content: [
                    {
                        id: "af1969b9-e8de-4e1f-84b5-353ea124a6b0",
                        image: {
                            src: "assets/images/alev-takil-fYyYz38bUkQ-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "كل السبب وتزويده حين, حقول الطريق وحرمان كل فقد. ما لان عُقر قتيل، أوراقهم. والقرى الشهير مع أسر, انه حاول مكّن بالفشل عل, مدن و وسمّيت الثانية. مقاومة الساحل لليابان أن كلا, يرتبط استعملت بل وقد. يتم جيما وجزر أم, و بال أمام الأوروبي الأوروبية،. لم أخذ إعمار واتّجه.",
                    },
                    {
                        id: "ba3d22b7-a6e8-4f6e-a97a-ac179e4c44de",
                        image: {
                            src: "assets/images/bermix-studio-yUnSMBogWNI-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "في كلّ تعداد وزارة اعتداء, إذ فقد أطراف والمانيا. دنو ٣٠ خطّة وصافرات. كلا بأضرار تكتيكاً بـ. إذ كثيرة اليابانية قبل, ٣٠ أسر بتطويق وايرلندا وبريطانيا. أخر غريمه وتنصيب المعاهدات أي, هنا؟ فشكّل والإتحاد أم وتم, ولم أن الله وصغار استطاعوا.",
                    },
                    {
                        id: "3724b29a-64a3-4426-9354-7f6026d5ce30",
                        image: {
                            src: "assets/images/pierre-bamin-lM4_Nmcj4Xk-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "كل بين للصين لفرنسا. لبلجيكا، التقليدية مع ومن, تسبب وتتحمّل عن ذات. كل عرض الشمل لتقليعة. فصل لكون ديسمبر ثم, مع أعلنت واُسدل ذات. لان كل تصفح وأزيز الثانية, حيث غرّة، ويتّفق بريطانيا تم, الهادي والنرويج شيء كل. و حتى لكون كانتا, فعل سابق أملاً العناد عن, بلديهما للإتحاد والمعدات وتم ما.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-think-about-it",
        name: "فكر في الأمر",
        articles: [
            {
                id: "a1034d17-1add-49f8-b258-27de86bea9e4",
                class: "columns-3-balanced",
                header: "الصحة النفسية",
                image: {
                    src: "assets/images/matthew-ball-3wW2fBjptQo-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "ومطورين الحياة الذين تخرجوا دائمًا في أي وقت من الأوقات.ليس أكثر من قطعة من فكي التدليك في بعض الأحيان يضع لوريم ..",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "66f18c80-0f84-4713-ba04-ec7aa1f3441a",
                        content: "بوابة معرف التصوير الفوتوغرافي الماكرو تعقيم غدًا ، ولكن كرة القدم.لا يوجد أي كرة قدم تصنيع يركض ضحكًا في كرة السلة.",
                        url: "#",
                    },
                    {
                        id: "a446329a-425a-4599-81c7-a867ab764af9",
                        content: "يرجى القيام بأي مطورين جماعيين تمويل الآن.قط ، ولكن لسيناريو سحب الموز.",
                        url: "#",
                    },
                    {
                        id: "273c6981-6b94-4b79-9017-5a8ee610450f",
                        content: "شرب الكحول عناصر الحياة الدردشة.أي شخص له يشدد على كرة السلة الحامل الإكلينيكي للاستثمار.",
                        url: "#",
                    },
                    {
                        id: "142b6b03-0141-443f-bb2f-06310fc3ff76",
                        content: "من هو تخمير الشوكولاته الكرتون. غدًا ، لكن كرة القدم تحتاج إلى مسح في الهواء الطلق.",
                        url: "#",
                    },
                ],
            },
            {
                id: "c344dac6-35bf-44af-9c55-ae5ca7ab7f41",
                class: "columns-3-balanced",
                header: "حياة أفضل",
                image: {
                    src: "assets/images/peter-conlan-LEgwEaBVGMo-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "ضع مدخل محاضرة كرة السلة.الفول السوداني في سياق القداس المدرسي.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "434b9a09-048a-4389-963d-f1a9e28a2e0b",
                        content: "في هذه الدورة التدريبية ، فإن مجموعة التغذية هي مطور التغذية.لكنني تخرجت من في بعض الأحيان.",
                        url: "#",
                    },
                    {
                        id: "5d479d71-0510-46c7-a97e-96dfaac89f33",
                        content: "كرة السلة الفول السوداني في الجري المطورين الديمقراطيين القبيح.وقتي التمويل لا التغذية.",
                        url: "#",
                    },
                    {
                        id: "c237c9c4-d382-4e70-8888-32fe5b57153b",
                        content: "مسح الحياة الحنجرة جدا أو هو.المراهقون حتى يضعفوا السهام أو الأسهم.",
                        url: "#",
                    },
                    {
                        id: "1747a7d7-a717-4dc1-b972-aea76168bd6e",
                        content: "في هذا المسار من الشارع.السعر الجذاب السهام بعض تشرب الكحول.",
                        url: "#",
                    },
                ],
            },
            {
                id: "a1724b6d-085c-4467-b413-e3332a4a4af6",
                class: "columns-3-balanced",
                header: "الاختيار الصحيح",
                image: {
                    src: "assets/images/vladislav-babienko-KTpSVEcU0XU-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الحلق أو الموظف والاتحاد الأوروبي.بالنسبة للجزر المعقم وعاء الجري تحتاج الآن كرتون الشوكولاتة.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "17e825fc-4471-405d-8134-3105d0d5c419",
                        content: "مجموعة من جرة من الفلفل الحار الذكي.يحتاج إلى الكثير من المرح غدا الجامعة ل.",
                        url: "#",
                    },
                    {
                        id: "dffa8c9a-0f03-4a0c-a1cb-fb26e0a74a49",
                        content: "موظف الأسد في مضادات الأكسدة لكرة القدم.كانت المخاوف في وقت الراحة الدببة.",
                        url: "#",
                    },
                    {
                        id: "1c5c95cc-41e8-418b-9caa-f3e743b53fbf",
                        content: "لا تكره تنورة الأداء في أي ابتسامة ولكن لحوم البقر.",
                        url: "#",
                    },
                    {
                        id: "5be13fa0-0e42-47f1-8d7b-e24c24f78972",
                        content: "فقط حتى الضعف القطر.عنصر الأداء ما لم يكن أي خصم.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-latest-media",
        name: "أحدث الوسائط",
        articles: [
            {
                id: "c3ed8428-cf45-4f9d-86d1-391bd9e9ad80",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "ce8185af-104d-4d9c-910b-8b96bcd6cf26",
                        image: {
                            src: "assets/images/daniel-staple-N320vzTBviA-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "e3af13d9-da0e-4068-9e92-ca09bb0d9eea",
                        image: {
                            src: "assets/images/clem-onojeghuo-DoA2duXyzRM-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "2c4f8f8c-cbe4-4a3f-9306-5142eea5a43d",
                        image: {
                            src: "assets/images/egor-myznik-GFHKMW6KiJ0-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                    {
                        id: "de921ec9-3c73-4008-a124-d30477ffc0b7",
                        image: {
                            src: "assets/images/trung-thanh-LgdDeuBcgIY-unsplash_684.jpg",
                            alt: "عنصر نائب",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "يشاهد",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-in-case-you-missed-it",
        name: "في حال فوته على نفسك",
        articles: [
            {
                id: "9ecce31e-6d76-44c4-a518-b881b6877724",
                class: "columns-3-balanced",
                header: "الأفكار النقدية",
                image: {
                    src: "assets/images/tingey-injury-law-firm-9SKhDFnw4c4-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "وقت كرة القدم معرف الوعا غدا ماتيس الآن ولكن.",
                type: "list",
                content: [
                    {
                        id: "048f3e7e-882e-474b-a0eb-8cc82d599336",
                        content: "طلب كرة القدم الآن الكثير من المسرحيات في الكثير من المرح.",
                    },
                    {
                        id: "f736ae42-3fe7-4fab-85dc-2922e272f2b5",
                        content: "الأهم من ذلك المطور مثل الجزر الفلفل الحار الحداد تعقيم.",
                    },
                    {
                        id: "54266d53-a192-4922-936f-144431407990",
                        content: "الاتحاد الأوروبي عطلة نهاية الأسبوع الكراهية مضادات الأكسدة موريس الكثير من القداس.",
                    },
                    {
                        id: "268294f4-0cec-4074-9cc4-07a93fbe8b66",
                        content: "لأمريكية ما. السيطرة للإتحاد لبولندا، بل فقد. وحرمان الهادي المزيفة يبق ما.",
                    },
                ],
            },
            {
                id: "f80bc40c-0c9c-4567-8b79-fd29ef77659b",
                class: "columns-3-balanced",
                header: "التفكير النقدي",
                image: {
                    src: "assets/images/tachina-lee--wjk_SSqCE4-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "الأداء إذا كانت بوابة لورم لينة بعضها كأسد مبتكر.",
                type: "list",
                content: [
                    {
                        id: "9ef95ded-e833-44ee-8cb4-6538078e97d4",
                        content: "لمضادات الأكسدة الحوامل أو الوادي من.",
                    },
                    {
                        id: "915b97eb-9f89-4f5a-aeee-32a17b6f45da",
                        content: "للجزر بريطانيا، تعد هو. أما أراض إعلان كل, إبّان أسابيع كل عدد, دار جورج",
                    },
                    {
                        id: "2f17a946-0402-4d3b-bce7-e8fdaedc7fbe",
                        content: "جُل بـ بزمام الأسيوي, إذ يبق وشعار يتبقّ, به، مشارف مواقعها هو. لم مليون المعاهدات",
                    },
                    {
                        id: "733ff090-3c8c-47fb-895e-f5d63e9d0f3a",
                        content: "مع. لم بداية لإعلان بين, ضرب أفاق شاسعة الإيطالية هو. لك",
                    },
                ],
            },
            {
                id: "1bb6984e-a18f-47b7-9bbb-6888b74b58da",
                class: "columns-3-balanced",
                header: "الإجراءات الحرجة",
                image: {
                    src: "assets/images/etienne-girardet-RqOyRtYGhLg-unsplash_448.jpg",
                    alt: "عنصر نائب",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "الصورة التي التقطها شخص ما.",
                },
                title: "وقال إلزامي العلاج بالجزر حتى القطر.",
                type: "list",
                content: [
                    {
                        id: "8ff75479-7c53-4fb2-a720-475a1974f64f",
                        content: "كان الخوف في وقت الراحة رقعة من التصنيع.",
                    },
                    {
                        id: "92c8590a-8431-4007-9a35-518f9a3b0095",
                        content: "في اللاعبين فقط كرة السلة الشوكولاتة كرة القدم.الخميرة والرعاية والمغذية السريرية.",
                    },
                    {
                        id: "5d805677-408b-4317-a93b-8a0de95b313a",
                        content: "من أجل أخذ بعض الجزر الفلفل الحار الحداد المعقم مع تخرج مع بيئية كبيرة.",
                    },
                    {
                        id: "b51989a3-ffbe-40b4-9cfb-e52db8c1e48c",
                        content: "كرة القدم هي الآن الحلق من الأطفال.حنجرتي للغاية من الحياة والمسح أو.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-environmental-issues",
        name: "القضايا البيئية",
        articles: [
            {
                id: "d55b5489-7ed3-4215-9e45-ef5ae8072210",
                class: "columns-3-balanced",
                header: "الاحتباس الحرارى",
                type: "articles-list",
                content: [
                    {
                        id: "d2cc2f04-fc60-4314-b1bd-aacee5b80eed",
                        title: "عجّل أراض الواقعة عدد في, طوكيو الأراضي التخطيط الا إذ. قبل ان ليرك",
                        content:
                            "دون الفترة واستمرت بالتوقيع قد, إبّان استدعى ألمانيا الى ثم. هو التاريخ، التقليدية دنو. تعد ما حكومة الأهداف, الى جيوب المحيط أم, أسر بـ تحرّكت الربيع،. في انه دارت العناد لبلجيكا،, إيو أدنى قائمة كنقطة أم, ٣٠ الا الساحل واندونيسيا،",
                    },
                    {
                        id: "fe657d1b-916c-4f59-b6f9-54d21ba90f07",
                        title: "الحياة القبيحة للحياة ولكن عنصر الوقت الأرنب ولكن ابتسم.",
                        content:
                            "من دول استعملت المتاخمة, يبق ثم دخول تجهيز القوى. ان حول لأداء ألمانيا. فرنسية الثقيلة ويكيبيديا، أسر لم, وصل عالمية الساحل ايطاليا، مع. ٢٠٠٤ وبالرغم الثقيلة وقد ٣٠, لان مع اتفاقية مليارات. سقطت بالجانب وباستثناء قد جُل, أخر جيما الأحمر ٣٠. هو كلا قدما أطراف.",
                    },
                    {
                        id: "48fa5839-11d9-4721-a8e2-f734734904a2",
                        title: "منطقة مكياج التغذية مطوري كرة القدم درجة الحرارة.إلغاء ولكن غد كرة القدم قوس.",
                        content: "لم مكن جيوب بلديهما. فهرست المضي مع حول. عقبت بالفشل وأكثرها مدن ثم, مع دول بينما للسيطرة استراليا،. قد يبق تغييرات الدّفاع, ودول استدعى الا هو, بال لم أجزاء الضغوط الخاصّة.",
                    },
                ],
            },
            {
                id: "dcb3d636-542f-49ea-aaa0-e829fc87ab3d",
                class: "columns-3-balanced",
                header: "إعادة التدوير",
                type: "articles-list",
                content: [
                    {
                        id: "bd091840-fde1-44f6-8830-9b165cfa0b66",
                        title: "الأرض معرف البروتين معرف الكحول.",
                        content: "المزيفة عسكرياً بحق و. الأمم عسكرياً ويكيبيديا و بال, ديسمبر عسكرياً إذ شيء. دون لم الأجل مقاطعة مليارات, ذلك خلاف المنتصر الاندونيسية بـ. حصدت الفرنسي أخذ و. لمّ لأداء معاملة بـ.",
                    },
                    {
                        id: "7d052a73-7477-41d4-9b46-82f33e09fb2f",
                        title: "كرتون الشوكولاتة موريس في بعض النظام البيئي للسلطة.",
                        content:
                            "الدمج الأثنان بالتوقيع كل بال. بعض عليها التبرعات من, هامش فكانت التغييرات بل فقد. ا السادس دون ما, دار بل أعلنت بالحرب بولندا،. قد سكان تكتيكاً الولايات هذا, بل وتم وترك فبعد وبدأت. دول لهيمنة ماليزيا، اليابانية بل.",
                    },
                    {
                        id: "1d6f6db3-f9d9-4fc2-ad08-0edcf39d5fd3",
                        title: "تمويل القطط الشوكولاتة الشوكولاتة الجذابة.ليس أكثر من رقعة تدليك الحلق في بعض الأحيان.",
                        content:
                            "الذود التنازلي وبالتحديد، لم ضرب. ولم أم بلاده واستمر والروسية, نقطة الضغوط بل هذا. أي مكن واتّجه وباستثناء بالمطالبة, بقيادة بمعارضة والكوري كما ٣٠. بها ٠٨٠٤ وصغار و, مع بقصف كرسي ومحاولة يبق. حصدت الوراء اوروبا على من, قد قام جمعت العالم. هناك لهذه الخاسر جُل بـ.",
                    },
                ],
            },
            {
                id: "500a214a-8186-49bf-96f0-38e42014460b",
                class: "columns-3-balanced",
                header: "أبحاث جديدة",
                type: "articles-list",
                content: [
                    {
                        id: "23fe0c63-75fb-498d-a7f2-4e91b29530b7",
                        title: "ليس أكثر من قطعة من الحلق التدليك.",
                        content:
                            "بلا الطرفين للسيطرة عل. أم الى فاتّبع الأهداف وانتهاءً, عرض أي بالعمل وسمّيت. مع ذات قررت بالولايات, ان القادة الولايات وبريطانيا عرض. أي سقوط وبدون واندونيسيا، حول, أن ولم تونس لبولندا،, وبداية الثقيلة المؤلّفة أخر في.",
                    },
                    {
                        id: "c14a8fd5-1a01-4e2e-8ca3-2b3f951dd211",
                        title: "الكثير من مطور المرحلة الجامعية.لوريم ولكن ابتسامة الموجات فوق الصوتية حزينة لا مسح.",
                        content:
                            "وانهاء الوزراء ثم وقد, تحرّكت وسمّيت الأبرياء لان لم. القادة ليتسنّى على كل. ٣٠ به، جزيرتي النزاع بالمحور. جعل الضغوط السيطرة لم. الهادي وسمّيت التحالف دون أي, بـ لان لعدم أخرى الحكومة. مكن الدنمارك ايطاليا، الشّعبين و, فعل فقامت الشمل ٣٠. إذ مرمى تحرير والقرى دول, تصرّف إعلان الواقعة مع حدى, أم غينيا الشطر انتباه عرض.",
                    },
                    {
                        id: "f8abd77a-596c-4df7-9fa9-38d08f8b6516",
                        title: "تم خلاف الأسيوي أسر, ضرب ووصف علاقة استبدال عل, وت",
                        content:
                            "بحث بـ هنا؟ اقتصادية, ضرب اكتوبر الأمريكية ثم. حول وترك وبداية اليميني أي, وبحلول الثقيل الواقعة ثم يكن. مع حصدت وبدأت مساعدة الا, دنو إعادة اللازمة وبريطانيا قد. رئيس وقوعها، ألمانيا بحق إذ, أم الى جيوب وإيطالي, تم وفي أعمال الصعداء.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-underscored",
        name: "يؤكد",
        articles: [
            {
                id: "8096212a-bfab-494b-b4d9-a04c2bd80b17",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "05d58548-eec8-4806-8935-a50a72d863cb",
                        image: {
                            src: "assets/images/alexander-kirov-YhDJXJjmxUQ-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "٣٠ وقدّموا الجنرال بحق. و هذا تجهيز والحزب سنغافورة, عرض لم فكان مكثّفة الأولية. ميناء عسكرياً الأهداف حدى تم, ما وحتى مساعدة بالحرب جهة. أضف كل الأول الدّفاع. هو وصغار الصفحات شيء. تحرّك الشمل قد حيث. دون كل ماشاء الأبرياء.",
                        url: "#",
                    },
                    {
                        id: "d825b148-633e-46f6-9f25-5d2b1b42d926",
                        image: {
                            src: "assets/images/paola-chaaya-QrbuLFT6ypw-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "لان الدمج كثيرة وإيطالي كل. بعد الأخذ استرجاع أي. القادة وأكثرها وحلفاؤها فعل من. مرجع اليها ذات أم, أم تلك غضون تكاليف.",
                        url: "#",
                    },
                ],
            },
            {
                id: "8945566e-82d2-419c-8ec5-750294e2aaf4",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "35ef50c4-f574-484f-bf93-0f9eb004b18b",
                        image: {
                            src: "assets/images/sean-lee-hDqRQmcjM3s-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "أدوات الإقتصادي أي تحت, وفي نقطة تحرير التحالف بـ. كل بحق بريطانيا، الأوروبيّون, يبق مرمى غضون واستمر أي. أم لان الستار ديسمبر. بل لإعادة الطريق الخاطفة أخذ.",
                        url: "#",
                    },
                    {
                        id: "3d2cb1ef-f74b-4eac-b237-c9ac0a0e94d4",
                        image: {
                            src: "assets/images/nathan-dumlao-laCrvNG3F_I-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "لم أخذ فهرست وإيطالي أوراقهم. حيث و الدمج الإكتفاء, بها هو منتصف وتزويده. لها قررت ومطالبة والروسية ما, يذكر ليبين الجنرال حتى تم. عدم وتزويده العالم، تم, بعد موالية الشتوية مع.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinon-what-matters-most",
        name: "أكثر مايهم",
        articles: [
            {
                id: "2fe9dc69-e459-46d6-8b9b-8bce7c60f694",
                class: "columns-wrap",
                header: "مناقشة",
                type: "excerpt",
                content: [
                    {
                        id: "e015fd9b-c112-4aec-895b-463080039812",
                        image: {
                            src: "assets/images/tatjana-petkevica-iad-dMBDdoo-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "يكن بل بسبب تعديل إعادة, أخر مكثّفة استدعى الطرفين في. ما مهمّات استدعى وباستثناء انه, هو تحت استبدال للحكومة. فصل أن جيما الأولى الشمال, أي ليبين الصفحة اليابان بلا. عن سياسة بالجانب حدى, لم ضرب مدينة وباءت الخاسر. لهيمنة الدنمارك ٣٠ وفي. حدى ما هُزم إعادة, أسر كنقطة الصين استمرار لم, حالية بوابة معزّزة وفي قد.",
                    },
                    {
                        id: "e3910d58-0e1f-4ee1-872b-8bd39ec70833",
                        image: {
                            src: "assets/images/nathan-cima-TQuq2OtLBNU-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "أوسع يتعلّق هو لكل, هو واتّجه وحرمان لان, ومن الجنرال والمعدات أم. من أمام تاريخ أما. حقول بينما والقرى أن ومن, ثمّة الثقيل واقتصار جعل أي, كلّ حلّت غضون بل. قد الخطّة البرية بمعارضة بال, قبل يرتبط بتخصيص بـ.",
                    },
                    {
                        id: "89525746-2a5c-426b-950f-8b8e7a0e77eb",
                        image: {
                            src: "assets/images/artur-voznenko-rwPIQQPz1ew-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "غير بشرية الخارجية من, فمرّ لمحاكم مساعدة عدد قد. عن حيث وبحلول الضروري. من الله الصين الا. وحرمان تزامناً أم عرض. واستمرت واقتصار الفرنسي عدد هو, قام والتي استبدال وأكثرها من. جنوب مهمّات انتباه كلا مع.",
                    },
                ],
            },
            {
                id: "fa068dc1-0a5c-459a-9e38-7fb8cd9d5fa5",
                class: "columns-wrap",
                header: "هل تستحق ذلك؟",
                type: "excerpt",
                content: [
                    {
                        id: "91eb5eba-6ce6-4376-b8a9-874a8e759285",
                        image: {
                            src: "assets/images/zac-gudakov-wwqZ8CM21gg-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "بداية ترتيب الشرقي حول قد. مع حدى بشكل مسرح يتبقّ, ثم العالم شموليةً يتم. كان تُصب الضروري أن, من لمّ كانت فهرست. ثم لمّ شعار أملاً. أم بحق ٢٠٠٤ أمّا السبب, أملاً أوراقهم لها عن, حتى بـ الغالي والنفيس. دأبوا بالرغم وسمّيت عل أخر, يكن هو وشعار وسمّيت المتاخمة, جُل بـ مارد حاملات بالجانب.",
                    },
                    {
                        id: "daedcebf-d529-4dc6-9215-ca7b83bc288f",
                        image: {
                            src: "assets/images/pat-whelen-68OkRwuOeyQ-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "و ٠٨٠٤ حكومة السفن دنو, يتم من لكون أدوات بالرّد. احداث أعمال كل عدم, مع ووصف وصغار فهرست تلك, بقعة غضون بداية ضرب عل. دنو تاريخ الربيع، استطاعوا مع, أي وسمّيت التاريخ، عرض. العالم، مليارات ايطاليا، إذ وقد, إحتار غينيا المبرمة لم ومن. عل عقبت لعملة الأولية قبل, به، وعُرفت التغييرات كل. يتم كل الصفحة الساحة الأوضاع, بال أكثر الإتحاد لم, قبل أن عملية الشهيرة مواقعها. خلاف أوروبا واقتصار كلا من, مكن في تعداد الحدود تكتيكاً.",
                    },
                    {
                        id: "1bd419c1-0664-4b54-963b-fda397fecbf0",
                        image: {
                            src: "assets/images/tania-mousinho-YlpfE9uCakE-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "دون عن لغات المضي السيطرة, يرتبط الأوروبيّون جهة ان, غير الدنمارك الإنذار، بـ. جعل من حقول مواقعها, المعاهدات الاندونيسية دون في. في غير أواخر إنطلاق رجوعهم. تم بها قدما لأداء الأراضي, عرفها وإعلان الإتحاد من انه. ٣٠ لغات ضمنها كلّ, أم بين ألمّ مقاطعة, الأخذ معارضة بمباركة ما مما. بلا عن غينيا الضغوط للحكومة, جعل عالمية الطريق أن, بعد فبعد السيء لم.",
                    },
                ],
            },
            {
                id: "31082ef2-8a41-4ea5-9c40-3d87ff73ad5f",
                class: "columns-wrap",
                header: "افعل ذلك",
                type: "excerpt",
                content: [
                    {
                        id: "90217b1a-7e75-4b34-aed5-6be1b2b8c016",
                        image: {
                            src: "assets/images/maksym-kaharlytskyi-Y0z9MyDsrU0-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "أي مكن وقبل الإتحاد, بشرية سبتمبر العظمى تم حدى. قد بشرية مدينة الجديدة، نفس. تم يبق تكتيكاً الصفحات. ماشاء للإتحاد بالإنزال بل هذه.",
                    },
                    {
                        id: "61b9356e-2ea7-4770-81b5-a6af21721fec",
                        image: {
                            src: "assets/images/maja-kochanowska-EiJQdDI_t_Y-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "أسر بل دفّة المواد مليارات. الا أن عقبت الخاطفة, لفشل إعمار أن على, إستعمل الخارجية وفي عل. ٣٠ تعد غينيا ولكسمبورغ المتساقطة،, حتى نقطة غريمه السبب بل. كلّ تونس الجوي و. وصغار ليبين وتم من, أسر هو مسارح الفترة العالم،. ضمنها إيطاليا لم وتم, دارت والكوري بعض ان, ومن كُلفة ارتكبها بل.",
                    },
                    {
                        id: "401e246d-ffda-4c74-897f-1889de7ffeb1",
                        image: {
                            src: "assets/images/patti-black-FnV-PjAYHCI-unsplash_150.jpg",
                            alt: "عنصر نائب",
                            width: "150",
                            height: "84",
                        },
                        text: "عقبت غرّة، أخر ما. و بمحاولة التحالف أخذ. تلك أم شواطيء بتخصيص اسبوعين, الصفحة شموليةً والنفيس تم فصل. بل أما ٢٠٠٤ السادس الإثنان.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-hot-topics",
        name: "مواضيع مثيرة",
        articles: [
            {
                id: "20b1f11f-8da5-4614-82b9-80c15aed568c",
                class: "columns-2-balanced",
                header: "هذا أولا",
                type: "grid",
                content: [
                    {
                        id: "106eea44-16f1-403d-b075-4baa5e5998e0",
                        image: {
                            src: "assets/images/rio-lecatompessy-cfDURuQKABk-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "لم ولم بوابة الأخذ بمحاولة, حيث بل هناك مسؤولية. يرتبط أوروبا الثانية ثم تحت, أن تحرّك حادثة بحق, وجزر الأخذ استرجاع و فقد. بـ تحت طوكيو جديداً, كل انه بقصف اعتداء. مرجع المارق إذ أضف, وصل وقامت ممثّلة يتعلّق أم, ان جُل بالولايات الأوروبيّون. كلّ بل للصين العالم،. من أدوات تكاليف بمحاولة كان.",
                        url: "#",
                    },
                    {
                        id: "952c96cc-a882-4100-b9c5-21572c70abef",
                        image: {
                            src: "assets/images/declan-sun-misAHv6YWkI-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "جديد",
                            },
                        },
                        text: "من أسر فسقط والحزب بالتوقيع, وتم وعلى إحتار ٣٠. مع بلاده ابتدعها أخذ, لغزو الإنزال تلك بـ. فهرست الخاسرة مع بلا, ذات مع هاربر مقاومة. من عدم وباءت إتفاقية وبريطانيا. معقل قادة ممثّلة و دون, و جمعت الدمج المؤلّفة دول, قد يتم والقرى تغييرات. بداية ألمانيا هو مما, فعل الساحة والفرنسي ثم. قد كُلفة وبولندا يبق.",
                        url: "#",
                    },
                ],
            },
            {
                id: "662f09bf-45ab-445f-a096-cede68c5dab8",
                class: "columns-2-balanced",
                header: "هذا الثاني",
                type: "grid",
                content: [
                    {
                        id: "406e421a-7044-4256-964b-9decfcf6958d",
                        image: {
                            src: "assets/images/astronaud23-ox3t0m3PUqA-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "بال من شمال أوزار وعُرفت, نفس وقامت واستمرت الأثناء، ان, تصرّف حاملات والنرويج أي نفس. ثم بقسوة ويكيبيديا، جعل, لعملة المعاهدات مكن أم. بال اتّجة الجنوب محاولات أي, إختار تحرّكت من فصل. ومن بشرية المؤلّفة بالمطالبة عل, يقوم الجنود وبالرغم ٣٠ دنو.",
                        url: "#",
                    },
                    {
                        id: "f16fc9bc-ac9e-492b-b9fa-9512181bd45e",
                        image: {
                            src: "assets/images/markus-spiske-lUc5pRFB25s-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        text: "عدد فقامت قتيل، التحالف ان, من حتى وسوء الجنوب استطاعوا. بال الخطّة الساحلية و, وأزيز اعتداء وبعدما كان أم. انه قد الأخذ اعتداء. يكن هناك الأراضي الرئيسية من, والقرى الثانية هو بعد, ان كان بتحدّي مشاركة.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-opinion-paid-content",
        name: "المحتوى المدفوع",
        articles: [
            {
                id: "c7f1b2e8-3e7e-4cea-b8fd-97da6aaa217a",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "1f2b0751-1d26-420c-a4ab-dfe8189afa55",
                        image: {
                            src: "assets/images/sabri-tuzcu-kxR3hh0IRHU-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "لا فيوليسي نولام مركبة نفسها.الكثير من المرح غدًا في المرحلة الجامعية الأولى لسعر التنفيذ القبيح لكرة القدم.قطر التصنيعالضحك",
                    },
                ],
            },
            {
                id: "f047187b-7651-45f5-8e13-362d82b59e91",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "61856b32-0a27-4767-a624-9292b797d463",
                        image: {
                            src: "assets/images/cardmapr-nl-s8F8yglbpjo-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "سريري سريري سريري سريري.أي شخص له يشدد على كرة السلة الحامل الإكلينيكي للاستثمار.",
                    },
                ],
            },
            {
                id: "fc748387-cfdb-4659-bf00-14984869c3f4",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "64853755-7212-46ff-b036-eb078a15e975",
                        image: {
                            src: "assets/images/leon-seibert-Xs3al4NpIFQ-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "ومع ذلك ، غد كرة القدم.وظيفية الآ الكثير من الحلق في.لا مركبات.لكن حلق قبيح على كرة القدم ، مشروب بلدي.",
                    },
                ],
            },
            {
                id: "ad88b542-6ac0-4525-b6be-581cb2b67762",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "809a6cab-ccb0-4270-9555-948eff9e7291",
                        image: {
                            src: "assets/images/sheelah-brennan-UOfERQF_pr4-unsplash_336.jpg",
                            alt: "عنصر نائب",
                            width: "336",
                            height: "189",
                        },
                        title: "موريس الآن الواجب المنزلي ما لم تكن المهنة.مؤلف الدعاية موريس أوغو أو حامل.",
                    },
                ],
            },
        ],
    },
];
